exports = module.exports = require("./../../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover{position:relative;display:inline-block}.popover .popover-overlay{position:absolute;background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.117647),0 1px 4px rgba(0,0,0,.117647);top:100%;min-width:100px;-webkit-transition:all .2s;transition:all .2s;overflow:hidden;height:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Components/Popover/index.less
 ** module id = 509
 ** module chunks = 0
 **/